import { Controller } from "@hotwired/stimulus";
import Choices from 'choices.js'
import feather from "feather-icons"
import changeInputCount from '../modules/changeInputCount'
import $ from 'jquery';
import _ from 'lodash';

export default class extends Controller {
  static targets = [
    'cityInput',
    'dateFromInput',
    'cityInputContainer',
    'roomsCount',
    'infoField',
    'guestsAdultsInput',
    'guestsChildrenInput',
    'roomsInput'
  ]

  static classes = [
    "button",
    "containerInner",
    "containerOuter",
    "highlightedState",
    "input",
    "item",
    "listDropdown",
    "listSingle",
  ];

  static values = {
    homepage: { type: Boolean, default: false },
    searchPlaceholder: { type: String, default: 'Type or pick a location' },
  }

  initialize() {
    if (this.data.get('recommendations') !== null && this.data.get('recommendations') !== 'null') {
      this.recommendations = JSON.parse(this.data.get('recommendations'));
      this.defaultChoices = this.recommendations.map(cityData => this.mapCityToChoiceOption(cityData, 'disable'));
      const defaultEmptyChoice = { value: '', label: '', selected: true, disabled: true };
      this.defaultChoices.unshift(defaultEmptyChoice);
    } else {
      this.recommendations = [];
      this.defaultChoices = [];
    }

    if (this.data.get('location') !== null) {
      let locationData = JSON.parse(this.data.get('location'));
      let selectedPlace = this.mapCityToChoiceOption(locationData, locationData.slug);

      this.defaultChoices = [...this.defaultChoices, selectedPlace];
    }
  }

  connect() {
    this.bindChoicesToCitiesInput();
    this.updateInfoField();
    this.element.querySelector("form").addEventListener("submit", this.submitForm.bind(this));
  }

  submitForm(event) {
    event.preventDefault();
    const form = event.target;
    form.submit();
  }

  updateInfoField() {
    var adultsCount = parseInt(this.guestsAdultsInputTarget.value) || 0;
    var childrenCount = parseInt(this.guestsChildrenInputTarget.value) || 0;
    var roomsCount = parseInt(this.roomsInputTarget.value) || 0;
    var adultsWord = adultsCount === 1 ? `${adultsCount} adult` : `${adultsCount} adults`;
    var childrenWord = childrenCount === 1 ? `${childrenCount} children` : `${childrenCount} childrens`;
    var roomsWord = roomsCount === 1 ? `${roomsCount} room` : `${roomsCount} rooms`;
    var text = `${adultsWord}${childrenCount > 0 ? ', ' + childrenWord : ''}, ${roomsWord}`;

    if(adultsCount >= 1 && adultsCount <= 9 && childrenCount >= 0 && childrenCount <= 9 && roomsCount >= 1 && roomsCount <= 5) {
      this.infoFieldTarget.innerHTML = text;
    }
  }

  bindChoicesToCitiesInput() {
    let self = this;

    const element = new Choices(this.cityInputTarget, {
      choices: self.defaultChoices,
      searchResultLimit: 25,
      renderChoiceLimit: 25,
      searchPlaceholderValue: self.searchPlaceholderValue,
      noResultsText: 'No results found. <br/>Check our recommeded locations:',
      removeItemButton: true,
      itemSelectText: '',
      shouldSort: false,
      searchFloor: 3,
      classNames: {
        button: ['choices__button', ...self.buttonClasses],
        containerInner: ['choices__inner', ...self.containerInnerClasses],
        containerOuter: ['choices', ...self.containerOuterClasses],
        highlightedState: ['is-highlighted', ...self.highlightedStateClasses],
        input: ['choices__input', ...self.inputClasses],
        item: ['choices__item', ...self.itemClasses],
        listDropdown: ['choices__list--dropdown', ...self.listDropdownClasses],
        listSingle: ['choices__list--single', ...self.listSingleClasses],
      },
      callbackOnCreateTemplates: function(template) {
        return {
          choice: ({ classNames }, data) => {
            return template(`
            <div class="${classNames.item.join(' ')} ${classNames.itemChoice.join(' ')} ${
              data.disabled ? classNames.itemDisabled : classNames.itemSelectable
            }" data-select-text="${this.config.itemSelectText}" data-choice ${
              data.disabled
                ? 'data-choice-disabled aria-disabled="true"'
                : 'data-choice-selectable'
            } data-id="${data.id}" data-value="${data.value}" ${
              data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
            }>
              <i class='mb-1 mx-2' data-feather='map-pin'
                height='15' width='15'></i> ${data.label}
              <span class='ms-2 small text-gray'>
                ${data.customProperties?.prefecture}
                </span>
            </div>
          `);
          },
        };
      },
      callbackOnInit: function() {
        if (self.recommendations.length === 0) { return }
        let recommended = self.recommendations.slice(0,6);
        let div = `
          <div id="hotel-searchbar--recommended-areas"
          class="hotel-searchbar--recommended-areas">
          <div class="container py-2">
          <div class="row">
        `;
        recommended.forEach(area => div += `
          <div class='col-12 col-sm-6'>
            <div class='d-flex hotel-searchbar--recommended-areas-tile'
                data-area-slug='${area.slug}'>
              <div class='me-2 hotel-searchbar--recommended-areas-photo'>
                <img src="${area.photo}" alt="${area.name}">
              </div>
              <div class='my-auto'>
                <div class='font-weight-600'>${area.name}</div>
                <div class='small hotel-searchbar--recommended-areas-tile--properties'>
                  ${area.hotels_count} properties
                </div>
              </div>
            </div>
          </div>
        `);
        let el = this.choiceList.element;
        el.insertAdjacentHTML("afterend", div);
      }
    });

    $('.hotel-searchbar--recommended-areas-tile').on('click', function() {
      element.setChoices(self.defaultChoices, 'value', 'label', true);
      element.setChoiceByValue(this.dataset.areaSlug);
      element.hideDropdown();
    });

    element.passedElement.element.addEventListener('showDropdown', function() {
      $(element.choiceList.element).hide();
      $('#hotel-searchbar--recommended-areas').show();
      feather.replace();
    });

    element.passedElement.element.addEventListener('hideDropdown', function() {
      $(element.input.element).val('');
    });

    element.passedElement.element.addEventListener('search', _.debounce(async function(event) {
      $(element.choiceList.element).show();
      $('#hotel-searchbar--recommended-areas').hide();

      const data = await fetch(`/api/location/autocomplete?q=${encodeURIComponent(event.detail.value)}`);
      const results = await data.json();
      const choices = results.map(cityData => self.mapCityToChoiceOption(cityData, 'selectedCityID'));
      element.setChoices(choices, 'value', 'label', true);

      if(event.detail.resultCount === 0 || choices.length === 0) {
        $('#hotel-searchbar--recommended-areas').show();
      }
      feather.replace();
    }, 400));

    element.passedElement.element.addEventListener('removeItem', function() {
      feather.replace();
    });

    element.input.element.addEventListener('input', function() {
      if($(this).val().length < 3) {
        $(element.choiceList.element).hide();
        $('#hotel-searchbar--recommended-areas').show();
      }
    });
  }

  changeInputCount(event) {
    changeInputCount(event);
    // After changing the value, update the infoField
    this.updateInfoField();
  }

  disconnect() {
    // Without this choices will be initialized second time on turbloinks:load
    this.resetChoicesElements()
  }

  resetChoicesElements() {
    $(this.cityInputTarget).appendTo($(this.cityInputContainerTarget))
      .removeClass('choices__input', 'is-hidden')
      .removeAttr('data-choice');
    $(this.element).find('.choices').remove();
  }

  mapCityToChoiceOption(cityData, selectedCityID) {
    return {
      value: cityData.slug,
      label: cityData.name,
      customProperties: {
        hotels_count: cityData.hotels_count,
        prefecture: cityData.prefecture,
        photo: cityData.photo
      },
      selected: (slug => slug === selectedCityID)(cityData.slug)
    }
  }

  focusCityInput() {
    this.cityInputTarget.click();
  }

  focusDateFromInput() {
    const originalInput = this.element.querySelector('input[data-datepicker-target="dateFrom"]');
    const flatpickrWrapper = originalInput?.closest("[data-controller='datepicker']");
    const readonlyInput = flatpickrWrapper?.querySelector('input[readonly="readonly"]');
    if (readonlyInput) { readonlyInput.click(); };
  }
}
